import FilterContext from '@jetshop/core/components/Filters/FilterContext';
import PaginationContext from '@jetshop/core/components/Pagination/PaginationContext';
import { PaginationBehaviour } from '@jetshop/ui/Pagination';
import React, { Component } from 'react';
import { Query } from 'react-apollo';
import styled from 'react-emotion';
import GridProduct from '../GridProduct';
import ListProduct from '../ListProduct';
import Pagination from '../Pagination';
import ProductGrid from '../ProductGrid';
import ProductList from '../ProductList';
import UniversalProductsQuery from './UniversalProducts.gql';

export const UniversalWrapper = styled('section')``;

const PaginationWrapper = styled('div')`
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  border-top: 1px solid #9a9a9a;
  > div {
    align-items: center;
  }
  button {
    padding: 10px 20px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: white;
    background: #212121;
    &:disabled {
      opacity: 0.3;
    }
  }
`;

export default class UniversalProducts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productView: 'grid',
    };
  }
  changeView = (view) => {
    this.setState({ productView: view });
  };
  render() {
    const { catId, mainCat, hasSelector, modelSelected } = this.props;

    const { productView } = this.state;

    if (!catId) return null;

    return (
      <FilterContext.Consumer>
        {({ activeFilters }) => (
          <PaginationContext.Consumer>
            {({ currentPage, goToPage, perPage }) => {
              const offset = perPage * (currentPage - 1);
              const first = perPage;

              return (
                <UniversalWrapper>
                  <Query
                    query={UniversalProductsQuery}
                    variables={{
                      catId: catId,
                      offset: offset,
                      first: first,
                      listFilters: activeFilters.listFilters,
                    }}
                  >
                    {({ loading, error, data }) => {
                      if (loading) return null;
                      if (error) return `Error!: ${error}`;

                      return (
                        <React.Fragment>
                          {productView === 'grid' ? (
                            <ProductGrid
                              products={data.category.products.result}
                              categoryPath={mainCat.primaryRoute}
                              ProductComponent={GridProduct}
                            />
                          ) : (
                            <ProductList
                              products={data.category.products.result}
                              categoryPath={mainCat.primaryRoute}
                              ProductComponent={ListProduct}
                            />
                          )}
                          <PaginationWrapper>
                            <PaginationBehaviour
                              currentPage={currentPage}
                              goToPage={goToPage}
                              perPage={perPage}
                              total={data.category.products.totalResults}
                            >
                              {(props) => <Pagination {...props} />}
                            </PaginationBehaviour>
                          </PaginationWrapper>
                        </React.Fragment>
                      );
                    }}
                  </Query>
                </UniversalWrapper>
              );
            }}
          </PaginationContext.Consumer>
        )}
      </FilterContext.Consumer>
    );
  }
}
